import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const noop = () => {};

export const generateBtnClassNames = ({
  disabled,
  size,
  theme,
  style,
  extraClass,
  fullWidth,
}) => classNames(
  'button',
  extraClass,
  {
    'button--disabled': disabled,
    [`button--${size}`]: size,
    [`button--${theme}`]: theme,
    [`button--${style}`]: style,
    'button--expanded': fullWidth,
  },
);

// istanbul ignore next
const Button = ({
  disabled,
  size,
  theme,
  style,
  extraClass,
  children,
  onClick,
  extraProps,
  fullWidth,
  title,
  dataTrackable,
  dataClickTracking,
  testAttribute,
}) => (
  <button
    data-test={testAttribute}
    disabled={disabled}
    title={title}
    data-trackable={dataTrackable}
    data-click-tracking={dataClickTracking}
    className={generateBtnClassNames({
      disabled,
      size,
      theme,
      style,
      extraClass,
      fullWidth,
    })}
    onClick={onClick || noop}
    {...extraProps}
  >
    {children}
  </button>
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  size: PropTypes.oneOf(['small', 'large']),
  theme: PropTypes.oneOf(['primary', 'secondary', 'clear', 'hollow']),
  style: PropTypes.string,
  fullWidth: PropTypes.bool,
  extraClass: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  extraProps: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.bool])),
  dataTrackable: PropTypes.string,
  dataClickTracking: PropTypes.string,
  testAttribute: PropTypes.string,
};

export default Button;
